import { render } from "./AboutTestsModal.vue?vue&type=template&id=a9a4fb94&scoped=true"
import script from "./AboutTestsModal.vue?vue&type=script&lang=js"
export * from "./AboutTestsModal.vue?vue&type=script&lang=js"

import "./AboutTestsModal.vue?vue&type=style&index=0&id=a9a4fb94&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a4fb94"]])

export default __exports__